import { AppState } from "@Store/index";
import { shallowEqual, useSelector } from "react-redux";
import { Suspense, lazy } from "react";
import wrapperHOC from "@Utils/wrapperHOC";

const ToastNotification = lazy(() => import("./ToastNotification"));

const ToastNotificationWrapper = () => {
  const show = useSelector(({ toastData }: AppState) => toastData.show, shallowEqual);

  return (
    <div>
      {show && (
        <Suspense fallback={<div>Loading...</div>}>
          <ToastNotification />
        </Suspense>
      )}
    </div>
  );
};

export default wrapperHOC(ToastNotificationWrapper, {
  componentName: "ToastNotificationWrapper-ToastNotification-Global",
  showForChina: true,
});
